<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <!-- Right-aligned lines + arrow to the left (reading direction). -->
    <path
      d="M12 3.25H2M12 7H5.5M12 10.75H4"
      class="stroke"
      stroke-width="1.4"
      stroke-linecap="round"
    />
    <path
      d="M4.75 5.75L2.25 7L4.75 8.25"
      class="stroke"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OnboardingRtlIcon",
});
</script>

<style scoped lang="scss">
@use "../icon.scss";
</style>
